module.exports = __webpack_public_path__ + "static/media/tick.9167c045.svg";